export const QueryKeys = {
  GetMembers: 'getMembers',
  GetMember: 'getMember',
  GetRoles: 'getRoles',
};
